import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { api } from "../lib/api";

export default function ProtectedRoute({ children }) {
  const location = useLocation();
  const [status, setStatus] = useState(location.state?.user ? "ok" : null);

  useEffect(() => {
    if (location.state?.user) return;
    let cancelled = false;
    (async () => {
      try {
        await api.get("/auth/me");
        if (!cancelled) setStatus("ok");
      } catch {
        if (!cancelled) {
          // Remember where the user was trying to go so we can resume after
          // Google auth (works for Web Share Target / PWA links too).
          try {
            const target = (location.pathname || "") + (location.search || "");
            if (target && target !== "/" && target !== "/app") {
              sessionStorage.setItem("mise_post_login_redirect", target);
            }
          } catch {}
          setStatus("no");
        }
      }
    })();
    return () => { cancelled = true; };
  }, [location.state, location.pathname, location.search]);

  if (status === null) {
    return (
      <div className="min-h-screen flex items-center justify-center text-[hsl(var(--muted-foreground))]">
        <div className="flex gap-2">
          <span className="w-2 h-2 rounded-full bg-[hsl(var(--primary))] simmer" />
          <span className="w-2 h-2 rounded-full bg-[hsl(var(--secondary))] simmer-2" />
          <span className="w-2 h-2 rounded-full bg-[hsl(var(--primary))] simmer-3" />
        </div>
      </div>
    );
  }
  if (status === "no") return <Navigate to="/" replace />;
  return children;
}
